export default __webpack_public_path__ + "static/media/README.a74f9f20.md";